import { render } from "./CreateResponse.vue?vue&type=template&id=0261bee0&scoped=true"
import script from "./CreateResponse.vue?vue&type=script&lang=js"
export * from "./CreateResponse.vue?vue&type=script&lang=js"

import "./CreateResponse.vue?vue&type=style&index=0&id=0261bee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0261bee0"]])

export default __exports__